import { AudioRecordingSection } from './sections/AudioRecordingSection'
import { ScreenRecordingSection } from './sections/ScreenRecordingSection'

export function RecordingSettings(props: { inSession: boolean }) {
    return (
        <div className="flex flex-col gap-[10px]">
            <AudioRecordingSection inSession={props.inSession} />
            <ScreenRecordingSection inSession={props.inSession} />
        </div>
    )
}
